/**
 * Enables type-checking that is not affected by having multiple versions of
 * this library installed
 */
// The string here is used as the type description for the type checker
const MARKER_SYMBOL = Symbol.for('@attain-apps/UserFriendlyError')

/**
 * Error that can be displayed to an end-user. Generally, these errors should
 * not reveal any sensitive information or potential exploits in the system.
 * Instead, they should be simple, generic, easy-to-understand errors.
 *
 * **NOTE:** It is generally recommended to use one of the subclasses of this
 * class as they provide information in a standardized way, which makes
 * debugging easier and the user-experience more consistent
 */
export class UserFriendlyError extends Error {
  // NOTE: must be all upper case to avoid naming collision with the class name
  public static readonly NAME: string = 'UserFriendlyError'
  public override readonly name: string = UserFriendlyError.NAME

  // Used by TypeChecker
  private readonly [MARKER_SYMBOL] = true as const

  constructor(
    message: string,
    public readonly actualError?: Error,
  ) {
    super(message)
    // Used the actual error's stack trace, since that is usually more relevant
    if (actualError) {
      this.stack = actualError.stack
    }
  }
}
export namespace UserFriendlyError {
  // NOTE: not using @attain-apps/type-guards as that would introduce circular imports
  export function isUserFriendlyError(val: unknown): val is UserFriendlyError {
    return !!(val as UserFriendlyError)?.[MARKER_SYMBOL]
  }
}
